module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-300.woff2?4f1777b70133ddc6ca8b6fb3266f6a22";